import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpService } from 'src/app/services/http-wrapper.service';
import { ErrorMessageComponent } from 'src/app/shared/error-message/error-message.component';

@Component({
  selector: 'app-manage-group-members',
  templateUrl: './manage-group-members.component.html',
  styleUrls: ['./manage-group-members.component.css']
})
export class ManageGroupMembersComponent implements OnInit {
  @ViewChild(ErrorMessageComponent)

  public errorComponent!: ErrorMessageComponent;
  usersList: any;
  constructor(public httpService: HttpService,) { }

  ngOnInit(): void {
    this.httpService.startCallGroup(1,"Add Users");
    this.loadConfiguration();
  }

  loadConfiguration() {
    this.httpService.get("assets/users.json", this.errorComponent)
      .subscribe((dummyData) => {
        this.usersList = dummyData;
      });
  }
}
